/**
 * Swiper 实例创建器
 * 提供 Swiper 轮播图的封装和初始化功能
 * 
 * @module common/components/CreateSwiper
 * @author wei<innereyecw@gmail.com>
 * @version 5.0.0
 */
(function (global) {
  "use strict";

  // 确保命名空间存在
  if (!global.watashi) {
    global.watashi = {};
  }
  if (!global.watashi.common) {
    global.watashi.common = {};
  }

  const common = global.watashi.common;
  const logger = (global.watashi.core && global.watashi.core.logger) || console;

  /**
   * Swiper 实例创建器
   * @class CreateSwiper
   * 
   * @example
   * new watashi.common.CreateSwiper({
   *   container: '#mySwiper',
   *   swiperParams: {
   *     autoplay: { delay: 5000 },
   *     pagination: { el: '.swiper-pagination', clickable: true }
   *   }
   * });
   */
  common.CreateSwiper = (function () {
    const defaults = {
      container: '',
      swiperParams: {},
    };

    /**
     * 创建 Swiper 实例
     * @param {Object} options - 配置选项
     */
    function CreateSwiper(options) {
      this.settings = {...defaults, ...options};
      this.swiperInstance = null;
      this.init();
    }

    const _createSwiper = CreateSwiper.prototype;

    /**
     * 初始化 Swiper
     */
    _createSwiper.init = function () {
      if (common.exists(this.settings.container)) {
        this.swiperInstance = this.initializeSwiper();
      } else {
        logger.log(`Swiper init failed: ${this.settings.container}`, 'warn');
      }
    };

    /**
     * 创建 Swiper 实例
     * @returns {Swiper|null} Swiper 实例
     */
    _createSwiper.initializeSwiper = function () {
      if (typeof Swiper === 'function') {
        try {
          return new Swiper(this.settings.container, this.settings.swiperParams);
        } catch (e) {
          logger.error(`Swiper error: ${e.message}`);
        }
      } else {
        logger.log('Swiper library not loaded', 'warn');
      }
      return null;
    };

    /**
     * 获取 Swiper 实例
     * @returns {Swiper|null}
     */
    _createSwiper.getSwiper = function () {
      return this.swiperInstance;
    };

    return CreateSwiper;
  })();

})(typeof window !== "undefined" ? window : this);
